
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { APP_DI_CONFIG } from '../../../config/app.config';
import { appToaster } from '../../../config/app-toaster.config';
import { NotificationService } from '../../../core/services/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Authenticationservice } from 'src/app/core/authentication/authenticationService';
import { UserService } from 'src/app/shared/services/http';
import { DashboardService } from 'src/app/shared/services/http/user/dashboard.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-download-image',
  templateUrl: './download-image.component.html',
  styleUrls: ['./download-image.component.css']
})
export class DownloadImageComponent implements OnInit {

  ForgotPasswordForm: UntypedFormGroup | any;
  appSettings = APP_DI_CONFIG;
  ImageURL:string;
  Info:string;
  Iserrmessage:any=false;
  imageEndpoint = `${environment.API_URL.Log.url}` + '/api/image/ImageUpload/?info=';
  constructor(
    private fb: UntypedFormBuilder,private userService:UserService,private route: ActivatedRoute,private http: HttpClient,
    private router: Router
  ) { 
    
  }
 
  ngOnInit(): void {
    //this.Info = this.route.queryParams['info']
    this.route.queryParams.subscribe((params: any) => {
      this.Info = params.info;
      this.Iserrmessage = true;
      if(this.Info==null)
      {
        this.Iserrmessage = false;
      }
    });
}
getImageSrc(imageName) {
  
  //return 'http://localhost:57686/api/ImageUpload?info=' + this.Info;
  return  environment.API_URL.Log.url + '/api/ImageUpload?info=' + this.Info;
}

  downloadImage() {
    let info = this.Info;
  
this.userService.GetImageView(this.Info).subscribe(blob => {
  //this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
 
    a.href = objectUrl;
    a.download = 'Image.jpg'; // optional (backend already sets it)
    a.click();
 
    URL.revokeObjectURL(objectUrl);

   });
}

downloadUserportal()
{
  //this.router.navigate(['/auth/login']); 
  const url = this.router.serializeUrl(
    this.router.createUrlTree(['/auth/login'])
  );
 
  window.open(url, '_blank');
}

downloaderror(){
  this.Iserrmessage = false;
}
}

